<!--
 * @Date: 2023-12-06 11:28:18
 * @Author: ym
 * @LastEditors: yanminw 2398988384@qq.com
 * @LastEditTime: 2025-12-16 17:10:50
 * @description: 
 * @FilePath: \yf_car\src\views\result.vue
-->
<template>
  <div class="parkingcoupons-pay">
    <!-- <navBar title="优惠券绑定状态" /> -->
    <!-- <div class="g-white-box g-stop-introd"> -->
    <div class="g-tips-box">
      <img :src="status == 0 ? require('@/assets/images/success.png') : require('@/assets/images/fail.png')" />
      <strong v-if="status == 0">添加成功</strong>
      <strong v-if="status == 1">添加成功</strong>
      <strong v-if="status == 1">出场时自动减免</strong>
      <strong v-if="status == 2">页面已失效</strong>
      <strong v-if="status == 2">绑定优惠券, 请重新扫码</strong>
      <!-- <div class="g-foot-box">
        <p class="u-updata-tips">若不抬杆，请拨打停车场服务热线</p> -->
      <!-- <footdiv></footdiv> -->
      <!-- </div> -->
    </div>
    <!-- </div> -->
    <div class="g-white-box g-stop-introd">
      <van-skeleton :row="5" :loading="loadings" :row-width="['100%', '100%', '100%', '100%']"> </van-skeleton>
      <ul class="g-list-two" v-if="!loadings">
        <li>
          <strong>车牌号码：</strong> <b>{{ $route.query.car_number }} </b>
        </li>
        <li>
          <strong>代缴账号：</strong>

          <b v-if="ruleDetails.company_id || ruleDetails.user_info">
            {{
              (ruleDetails.company_info && ruleDetails.company_info.name) ||
              ruleDetails.user_info.real_name ||
              ruleDetails.user_info.nick_name ||
              ruleDetails.user_info.name
            }}
          </b>
        </li>
        <li>
          <strong>最大金额：</strong><b>¥{{ ruleDetails.money }}</b>
        </li>
        <li>
          <strong>有效时间：</strong
          ><b v-if="parseTime(ruleDetails.end_time, '{y}') != 2099">
            {{ parseTime(ruleDetails.start_time, '{y}-{m}-{d}') }}
            -
            {{ parseTime(ruleDetails.end_time, '{y}-{m}-{d}') }}
          </b>
          <b v-else>永久</b>
        </li>
        <li>
          <strong>代缴次数：</strong><b> {{ ruleDetails.usable_num ? ruleDetails.usable_num : '不限' }} </b>
        </li>
        <!-- <li><strong>备注说明：</strong><b style="color: red"> 填写车牌后，将为您代缴停车费用 </b></li> -->
        <!-- <li><strong>已付金额</strong><b>¥{{}}</b></li> -->
        <!-- <li v-if="company_deduction_amount">
          <strong>企业代缴</strong><b>¥{{ company_deduction_amount }}</b>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {parseTime} from '@/utils/base'
import {carReimbursementRuleDetails} from '@/api/base'
export default {
  components: {Toast},
  data() {
    return {
      status: 1,
      loadings: true,
      ruleDetails: {},
      parseTime: parseTime,
    }
  },
  methods: {
    getDetails() {
      this.loadings = true
      carReimbursementRuleDetails({rule_id: this.$route.query.rule_id}).then(res => {
        this.loadings = false
        if (res.code === 1) {
          this.ruleDetails = res.data
        } else {
          Toast(res.data.msg)
        }
      })
    },
  },
  created() {
    this.status = this.$route.query.status
  },
  mounted() {
    this.getDetails()
    document.body.style.backgroundColor = '#f5f5f5'
  },
  beforeDestroy() {
    document.body.style.backgroundColor = '#fff'
  },
}
</script>
<style lang="scss" scoped>
.g-tips-box {
  width: 100%;
  height: auto;
  background: #fff;
  display: block;
  overflow: hidden;
  padding: 1.14rem 0;
  margin: 0;
}

.g-tips-box img {
  width: 2rem;
  height: auto;
  margin: 0 auto;
  display: block;
  overflow: hidden;
}

.g-tips-box strong {
  width: 100%;
  height: 0.44rem;
  line-height: 0.44rem;
  font-size: 0.38rem;
  font-weight: normal;
  color: #222;
  text-align: center;
  margin: 0.38rem 0 0;
  display: block;
  overflow: hidden;
}
</style>
